module.exports = __webpack_public_path__ + "static/media/flash.e6258072.png";